import { render } from "./ArticleOverlay.vue?vue&type=template&id=7a1c3810"
import script from "./ArticleOverlay.vue?vue&type=script&lang=js"
export * from "./ArticleOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__